'use client';

import { Suspense } from 'react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import classNames from 'classnames';
import { Form, Formik } from 'formik';

import { IBranchEssential } from 'app/interfaces/branches';
import { getSearchParams } from 'app/utility/helpers';
import WithFormFieldCheckable from 'app/components/common/WithFormFieldCheckable';

interface IFilterBranchFormFields {
  branch: string[];
}

function FilterBranchInner({ items }: { items: IBranchEssential[] }) {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  function submit(values: IFilterBranchFormFields) {
    router.replace(
      `${pathname}?${getSearchParams(searchParams, [
        { name: 'branch', value: values.branch },
        { name: 'page', value: undefined }
      ])}`,
      { scroll: false }
    );
  }

  return (
    <Formik
      initialValues={
        {
          branch: searchParams.getAll('branch') || []
        } as IFilterBranchFormFields
      }
      onSubmit={values => {
        submit(values);
      }}
    >
      {({ values, submitForm, resetForm }) => (
        <Form
          className="flex flex-wrap gap-2"
          onInput={() => {
            submitForm();
            if (values.branch?.length === items.length) {
              resetForm({ values: { branch: [] } });
            }
          }}
          onReset={() => {
            resetForm({ values: { branch: [] } });
            submitForm();
          }}
        >
          <button
            type="reset"
            className={classNames(
              'button-default p-3 rounded uppercase border text-white text-p3 font-medium cursor-pointer',
              {
                'border-brown bg-brown': !values.branch?.length,
                'border-white-30': !!values.branch?.length,
                'hover:border-white': !!values.branch?.length
              }
            )}
            key="reset"
          >
            Все
          </button>
          {items.map(item => {
            return (
              <WithFormFieldCheckable
                name="branch"
                value={item.slug}
                key={item.id}
              >
                {({ field, value, checked }) => (
                  <label
                    className={classNames(
                      'button-default p-3 rounded uppercase border text-white text-p3 font-medium cursor-pointer',
                      {
                        'border-brown bg-brown': checked,
                        'border-white-30': !checked,
                        'hover:border-white': !checked
                      }
                    )}
                  >
                    <span>{item.address}</span>
                    <input
                      {...field}
                      checked={checked}
                      value={value}
                      type="checkbox"
                      className="hidden"
                    />
                  </label>
                )}
              </WithFormFieldCheckable>
            );
          })}
        </Form>
      )}
    </Formik>
  );
}

export default function FilterBranch(props: { items: IBranchEssential[] }) {
  return (
    <Suspense fallback={null}>
      <FilterBranchInner {...props} />
    </Suspense>
  );
}
